<div style="margin-left: 20px;">
    <form [formGroup]="SettingsForm">
        <div class="form-group row">
            <fieldset>
                <legend>
                    <input type="checkbox" [formControl]="EnableExport" />
                    <span class="uv-checkbox-label">Enable Export</span>
                </legend>
            </fieldset>
        </div>
        <div class="form-group row" [ngClass]="{'uv-disabled':!ExportEnabled}">
            <div class="uv-row">
                <span class="col-lg-2">Do export from:</span>
                <select class="col-lg-3" [formControl]="ExportOrigin"
                        [ngClass]="{'show-error':SettingsForm.hasError('validExportOrigin'), 'uv-disabled':!EnableExportOrigin}">
                    <option value="agent">Agent</option>
                    <option value="server">Server</option>
                </select>
                <button [disabled]="!isLicenseValid" type="button" style="margin-left: 20px !important;" pButton icon="fa fa-file-o" iconPos="left"
                        label="Export Now (from server)" (click)="ExportNow()"></button>
                <button type="button" pButton label="Test Halo Connection" [disabled]="!enableTestHaloButton" title="Test/Verify Halo connection credentials" style="margin-left: 20px !important;"
                        (click)="testHaloConnect()"></button>
            </div>
        </div>
        <hr style="margin-top: 20px; margin-bottom: 20px;" />
        <div class="form-group row mb-3" [ngClass]="{'uv-disabled':!ExportEnabled}">
            <span class="col-lg-2">*Target Server URL:</span>
            <input class="col-lg-3" type="text" pInputText [formControl]="TargetServerApiURL" />
        </div>
        <div class="form-group row mb-3" [ngClass]="{'uv-disabled':!ExportEnabled}">
            <span class="col-lg-2">*Target Server API Username:</span>
            <input class="col-lg-3" type="text" pInputText [formControl]="TargetServerUsername" (keydown)="onUsernameKeyDownHandler($event)" />
        </div>
        <div class="form-group row mb-3" [ngClass]="{'uv-disabled':!ExportEnabled}">
            <span class="col-lg-2">*Target Server API Password:</span>
            <input class="col-lg-3" type="password" pInputText [formControl]="TargetServerPassword" (keydown)="onPasswordKeyDownHandler($event)" />
        </div>
        <div class="form-group row mb-3" [ngClass]="{'uv-disabled':!ExportEnabled}">
            <span class="col-lg-2">*Target Server Client ID:</span>
            <input class="col-lg-3" type="password" pInputText [formControl]="TargetServerClientID" (keydown)="onClientIdKeyDownHandler($event)" />
        </div>
        <div class="mb-3 row">
            <div>
                <input type="checkbox" [formControl]="UseMacAddressLookup" />
                <span class="uv-checkbox-label">Use MAC Address Lookup</span>
            </div>
        </div>
        <div class="mb-3 row">
            <div>
                <input type="checkbox" [formControl]="UseIpAddressLookup" />
                <span class="uv-checkbox-label">Use IP Address Lookup</span>
            </div>
        </div>
        <div class="form-group row" [ngClass]="{'uv-disabled':!ExportEnabled}">
            <fieldset>
                <legend>Export Settings</legend>
            </fieldset>
        </div>
        <hr style="margin-top: 20px; margin-bottom: 20px;" />
        <div class="form-group row mb-3" [ngClass]="{'uv-disabled':!ExportEnabled}">
            <span class="col-lg-2">*Client Name:</span>
            <input class="col-lg-3" type="text" pInputText [formControl]="ClientName" [ngClass]="{'show-error':SettingsForm.hasError('validClient')}" />
        </div>
        @if (SettingsForm.hasError('validClient')) {
        <div class="form-group row mb-3">
            <span class="col-lg-2"></span>
            <span class="col-lg-3 alert alert-danger">This value is required</span>
        </div>
        }

        <div class="form-group row mb-3" [ngClass]="{'uv-disabled':!ExportEnabled}">
            <span class="col-lg-2">Site Name:</span>
            <input class="col-lg-3" type="text" pInputText [formControl]="SiteName" />
        </div>

        <div class="form-group row">
            <div style="margin-left: 50px; margin-top: 10px; margin-bottom: 10px;" [ngClass]="{ 'uv-disabled':!ExportEnabled} ">
                <input type="checkbox" [formControl]="ExportDevices" />
                <span class="uv-checkbox-label">Export Devices</span>
            </div>
        </div>
        <div class="form-group row" [ngClass]="{'uv-disabled':!ExportEnabled}">
            <div style="margin-left: 50px; margin-top: 10px; margin-bottom: 10px;">
                <input type="checkbox" [formControl]="ExportConfigs" />
                <span class="uv-checkbox-label">Export Startup/Running Configs</span>
            </div>
        </div>
        <div class="form-group row">
            <div style="margin-left: 50px; margin-top: 10px; margin-bottom: 10px;" [ngClass]="{ 'uv-disabled':!ExportEnabled} ">
                <input type="checkbox" [formControl]="ExportDependencies" />
                <span class="uv-checkbox-label">Export Dependencies</span>
            </div>
        </div>

        <div class="form-group row" [ngClass]="{'uv-disabled':!ExportEnabled}">
            <div style="margin-left: 50px; margin-top: 10px; margin-bottom: 10px;">
                <input type="checkbox" [formControl]="ExportMapToLocation" />
                <span class="uv-checkbox-label">Export Map To Location</span>
            </div>
        </div>

        <div class="form-group row mb-3" [ngClass]="{'uv-disabled':!ExportEnabled}">
            <div class="uv-row">
                <span class="col-lg-2">Map file name:</span>
                <input class="col-lg-3" type="text" pInputText [formControl]="MapFileName" />
            </div>
        </div>
        <div class="form-group row mb-3" [ngClass]="{'uv-disabled': !ExportEnabled}">
            <div class="uv-row">
                <span for="mapFormat" class="col-lg-2">Map format:</span>
                <div class="col-lg-3">
                    <select class="form-control" [formControl]="MapFileExtension" id="mapFormat">
                        @for (option of mapDropdownOptions; track option) {
                        <option value="{{option}}">{{option}}</option>
                        }
                    </select>
                </div>
            </div>
        </div>

</form>
</div>
